import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import PriceField from "Components/UI/Form/PriceField";
import { DEFAULT_SERVICE } from "utils/options/DEFAULT_SERVICE";

const DeliveryOptions = [
  { Value: 0, Name: "Ej vald" },
  { Value: 1, Name: "E-post" },
  { Value: 2, Name: "Print" },
  { Value: 4, Name: "E-faktura" },
];

export default function EndcustomerFormStandardTerms({
  endcustomer,
  FORM_MODE,
  handleInputChange,
  agreementOptions,
  boolOptions,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Samma villkor som klient</InputLabel>
          <Select
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={endcustomer.SameAgreementAsClient}
            onChange={(e) =>
              handleInputChange("SameAgreementAsClient", e.target.value)
            }
            name="SameAgreementAsClient"
            label="Samma villkor som klient"
            size="small"
          >
            {boolOptions.map((item) => (
              <MenuItem key={item.Value} value={item.Value}>
                {item.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="LatePaymentInterestPercentage"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Dröjsmålsränta %"
          value={endcustomer?.LatePaymentInterestPercentage}
          onChange={(e) =>
            handleInputChange("LatePaymentInterestPercentage", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Referensränta adderas</InputLabel>
          <Select
            value={endcustomer.AddReferencePercentage}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(e) =>
              handleInputChange("AddReferencePercentage", e.target.value)
            }
            name="AddReferencePercentage"
            label="Referensränta adderas"
            size="small"
          >
            {boolOptions.map((item) => (
              <MenuItem key={item.Value} value={item.Value}>
                {item.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="OriginalFfd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="FFD dagar"
          value={endcustomer?.OriginalFfd}
          onChange={(e) => handleInputChange("OriginalFfd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1WaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 skapas efter dagar"
          value={endcustomer.Pm1WaitCreate}
          onChange={(e) => handleInputChange("Pm1WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm1Ffd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 FFD dagar"
          value={endcustomer.Pm1Ffd}
          onChange={(e) => handleInputChange("Pm1Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="Pm1Fee"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM1 Avgift SEK"
          value={endcustomer.Pm1Fee ? endcustomer.Pm1Fee : ""}
          onChange={(newVal) => handleInputChange("Pm1Fee", newVal)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2WaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 Skapas efter dagar"
          value={endcustomer.Pm2WaitCreate}
          onChange={(e) => handleInputChange("Pm2WaitCreate", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Pm2Ffd"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 FFD dagar"
          value={endcustomer.Pm2Ffd}
          onChange={(e) => handleInputChange("Pm2Ffd", e.target.value)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <PriceField
          name="Pm2Fee"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="PM2 Avgift SEK"
          value={endcustomer.Pm2Fee ? endcustomer.Pm2Fee : ""}
          onChange={(newVal) => handleInputChange("Pm2Fee", newVal)}
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="CollectionWaitCreate"
          disabled={FORM_MODE === "LOCKED" ? true : false}
          label="Inkasso fördröjning dagar"
          value={endcustomer.CollectionWaitCreate}
          onChange={(e) =>
            handleInputChange("CollectionWaitCreate", e.target.value)
          }
          type="number"
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Leveransalternativ Faktura</InputLabel>
          <Select
            value={
              endcustomer.DeliveryOptionInvoice
                ? endcustomer.DeliveryOptionInvoice
                : 0
            }
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(e) =>
              handleInputChange("DeliveryOptionInvoice", e.target.value)
            }
            name="DeliveryOptionInvoice"
            label="Leveransalternativ Faktura"
            size="small"
          >
            {DeliveryOptions.map((item) => (
              <MenuItem key={item.Value} value={item.Value}>
                {item.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Leveransalternativ Påminnelser</InputLabel>
          <Select
            value={
              endcustomer.DeliveryOptionReminder
                ? endcustomer.DeliveryOptionReminder
                : 0
            }
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(e) =>
              handleInputChange("DeliveryOptionReminder", e.target.value)
            }
            name="DeliveryOptionReminder"
            label="Leveransalternativ Påminnelser"
            size="small"
          >
            {DeliveryOptions.map((item) => (
              <MenuItem key={item.Value} value={item.Value}>
                {item.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Standardtjänst</InputLabel>
          <Select
            value={endcustomer.DefaultService ?? ""}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(e) =>
              handleInputChange("DefaultService", e.target.value)
            }
            name="DefaultService"
            label="Standardtjänst"
            size="small"
          >
            <MenuItem key={""} value={""}>
              {"Ej valt"}
            </MenuItem>
            {DEFAULT_SERVICE.map((item) => (
              <MenuItem key={item.Value} value={item.Value}>
                {item.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
